import { render, staticRenderFns } from "./HomestayOrderCard.vue?vue&type=template&id=03e5dd21&scoped=true"
import script from "./HomestayOrderCard.vue?vue&type=script&lang=js"
export * from "./HomestayOrderCard.vue?vue&type=script&lang=js"
import style0 from "./HomestayOrderCard.vue?vue&type=style&index=0&id=03e5dd21&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03e5dd21",
  null
  
)

export default component.exports